import * as CONSTANTS from './constants';
import { GET_COMPANY_PLAID_VERIFY_ACCOUNT_REQUEST } from './constants';

export const fetchCompaniesRequest = () => ({
  type: CONSTANTS.FETCH_COMPANIES_REQUEST
});

export const fetchCompaniesSuccess = (companies) => ({
  type: CONSTANTS.FETCH_COMPANIES_SUCCESS,
  companies
});

export const fetchCompaniesFail = (error) => ({
  type: CONSTANTS.FETCH_COMPANIES_FAIL,
  error
});

export const fetchCompanyDetailRequest = (id) => ({
  type: CONSTANTS.FETCH_COMPANY_DETAIL_REQUEST,
  id
});

export const fetchCompanyDetailSuccess = (data) => ({
  type: CONSTANTS.FETCH_COMPANY_DETAIL_SUCCESS,
  data
});

export const fetchCompanyDetailFail = (error) => ({
  type: CONSTANTS.FETCH_COMPANY_DETAIL_FAIL,
  error
});

export const createCompanyRequest = (payload) => ({
  type: CONSTANTS.CREATE_COMPANY_REQUEST,
  payload
});

export const createCompanySuccess = (data) => ({
  type: CONSTANTS.CREATE_COMPANY_SUCCESS,
  data
});

export const createCompanyFail = (error) => ({
  type: CONSTANTS.CREATE_COMPANY_FAIL,
  error
});

export const updateCompanyRequest = (id, payload, callBack, onError) => ({
  type: CONSTANTS.UPDATE_COMPANY_REQUEST,
  id,
  payload,
  callBack,
  onError
});

export const updateCompanySuccess = (data) => ({
  type: CONSTANTS.UPDATE_COMPANY_SUCCESS,
  data
});

export const updateCompanyFail = (error) => ({
  type: CONSTANTS.UPDATE_COMPANY_FAIL,
  error
});

export const fetchCompanyProfileRequest = (id) => ({
  type: CONSTANTS.FETCH_COMPANY_PROFILE_REQUEST,
  id
});

export const fetchCompanyProfileSuccess = (data) => ({
  type: CONSTANTS.FETCH_COMPANY_PROFILE_SUCCESS,
  data
});

export const fetchCompanyProfileFail = (error) => ({
  type: CONSTANTS.FETCH_COMPANY_PROFILE_FAIL,
  error
});

export const updateCompanyProfileRequest = (id, payload) => ({
  type: CONSTANTS.UPDATE_COMPANY_PROFILE_REQUEST,
  id,
  payload
});

export const updateCompanyProfileSuccess = (data) => ({
  type: CONSTANTS.UPDATE_COMPANY_PROFILE_SUCCESS,
  data
});

export const updateCompanyProfileFail = (error) => ({
  type: CONSTANTS.UPDATE_COMPANY_PROFILE_FAIL,
  error
});

export const acceptCompanyPermissionByOwnerRequest = (token) => ({
  type: CONSTANTS.ACCEPT_COMPANY_PERMISSION_BY_OWNER_REQUEST,
  token
});

export const acceptCompanyPermissionByOwnerSuccess = () => ({
  type: CONSTANTS.ACCEPT_COMPANY_PERMISSION_BY_OWNER_SUCCESS
});

export const acceptCompanyPermissionByOwnerFail = (error) => ({
  type: CONSTANTS.ACCEPT_COMPANY_PERMISSION_BY_OWNER_FAIL,
  error
});

export const declineCompanyPermissionByOwnerRequest = (token) => ({
  type: CONSTANTS.DECLINE_COMPANY_PERMISSION_BY_OWNER_REQUEST,
  token
});

export const declineCompanyPermissionByOwnerSuccess = (data) => ({
  type: CONSTANTS.DECLINE_COMPANY_PERMISSION_BY_OWNER_SUCCESS
});

export const declineCompanyPermissionByOwnerFail = (error) => ({
  type: CONSTANTS.DECLINE_COMPANY_PERMISSION_BY_OWNER_FAIL,
  error
});

export const fetchCompanyTypeRequest = () => ({
  type: CONSTANTS.FETCH_COMPANY_TYPE_REQUEST
});

export const fetchCompanyTypeSuccess = (data) => ({
  type: CONSTANTS.FETCH_COMPANY_TYPE_SUCCESS,
  data
});

export const fetchCompanyTypeFail = (error) => ({
  type: CONSTANTS.FETCH_COMPANY_TYPE_FAIL,
  error
});

export const fetchBusinessTypeRequest = () => ({
  type: CONSTANTS.FETCH_BUSINESS_TYPE_REQUEST
});

export const fetchBusinessTypeSuccess = (data) => ({
  type: CONSTANTS.FETCH_BUSINESS_TYPE_SUCCESS,
  data
});

export const fetchBusinessTypeFail = (error) => ({
  type: CONSTANTS.FETCH_BUSINESS_TYPE_FAIL,
  error
});

export const registerSilaCompany = (data) => ({
  type: CONSTANTS.REGISTER_SILA_COMPANY,
  payload: data
});

export const registerSilaCompanySuccess = (data) => ({
  type: CONSTANTS.REGISTER_SILA_COMPANY_SUCCESS,
  data
});

export const registerSilaCompanyFail = (error) => ({
  type: CONSTANTS.REGISTER_SILA_COMPANY_FAIL,
  error
});

export const registerSilaCompanyCancel = () => ({
  type: CONSTANTS.REGISTER_SILA_COMPANY_CANCEL
});

export const updateSilaCompany = (payload) => ({
  type: CONSTANTS.UPDATE_SILA_COMPANY,
  payload
});

export const updateSilaCompanySuccess = (data) => ({
  type: CONSTANTS.UPDATE_SILA_COMPANY_SUCCESS,
  data
});

export const updateSilaCompanyFail = (error) => ({
  type: CONSTANTS.UPDATE_SILA_COMPANY_FAIL,
  error
});

export const updateSilaCompanyCancel = () => ({
  type: CONSTANTS.UPDATE_SILA_COMPANY_CANCEL
});

export const getCompanyWallet = (payload) => ({
  type: CONSTANTS.GET_COMPANY_WALLET,
  payload
});

export const getCompanyWalletSuccess = (data) => ({
  type: CONSTANTS.GET_COMPANY_WALLET_SUCCESS,
  data
});

export const getCompanyWalletFail = (error) => ({
  type: CONSTANTS.GET_COMPANY_WALLET_FAIL,
  error
});

export const getCompanySilaKYB = (payload) => ({
  type: CONSTANTS.GET_COMPANY_SILA_VERIFICATION,
  payload
});

export const getCompanySilaKYBInterval = (payload) => ({
  type: CONSTANTS.GET_COMPANY_SILA_VERIFICATION_INTERVAL,
  payload
});

export const getCompanySilaKYBSuccess = (data) => ({
  type: CONSTANTS.GET_COMPANY_SILA_VERIFICATION_SUCCESS,
  data
});

export const getCompanySilaKYBFail = (error) => ({
  type: CONSTANTS.GET_COMPANY_SILA_VERIFICATION_FAIL,
  error
});

export const postCompanyRequestKYB = (payload) => ({
  type: CONSTANTS.POST_COMPANY_REQUEST_KYB,
  payload
});

export const postCompanyRequestKYBSuccess = (data) => ({
  type: CONSTANTS.POST_COMPANY_REQUEST_KYB_SUCCESS,
  data
});

export const postCompanyRequestKYBFail = (error) => ({
  type: CONSTANTS.POST_COMPANY_REQUEST_KYB_FAIL,
  error
});

export const postCompanyRequestKYBCancel = () => ({
  type: CONSTANTS.POST_COMPANY_REQUEST_KYB_CANCEL
});

export const uploadKYBDocument = (formData, companyId, callBack, onError) => ({
  type: CONSTANTS.UPLOAD_KYB_DOCUMENT_REQUEST,
  payload: {
    formData,
    companyId
  },
  callBack,
  onError
});

export const uploadKYBDocumentSuccess = (payload) => ({
  type: CONSTANTS.UPLOAD_KYB_DOCUMENT_SUCCESS,
  payload
});

export const uploadKYBDocumentFail = (error) => ({
  type: CONSTANTS.UPLOAD_KYB_DOCUMENT_FAIL,
  error
});

export const getPlaidLinkCompanyToken = (payload) => ({
  type: CONSTANTS.GET_PLAID_LINK_COMPANY_TOKEN_REQUEST,
  payload
});

export const getPlaidLinkCompanyTokenSuccess = (data) => ({
  type: CONSTANTS.GET_PLAID_LINK_COMPANY_TOKEN_SUCCESS,
  data
});

export const getPlaidLinkCompanyAccountConnected = () => ({
  type: CONSTANTS.PLAID_LINK_COMPANY_ACCOUNT_CONNECTED
});

export const getPlaidLinkCompanyTokenFail = (error) => ({
  type: CONSTANTS.GET_PLAID_LINK_COMPANY_TOKEN_FAIL,
  error
});

export const getPlaidCompanyAccount = (payload) => ({
  type: CONSTANTS.GET_PLAID_COMPANY_ACCOUNT_REQUEST,
  payload
});

export const getPlaidCompanyAccountSuccess = (data) => ({
  type: CONSTANTS.GET_PLAID_COMPANY_ACCOUNT_SUCCESS,
  data
});

export const getPlaidCompanyAccountFail = (error) => ({
  type: CONSTANTS.GET_PLAID_COMPANY_ACCOUNT_FAIL,
  error
});

export const getCompanyPlaidVerifyAccounts = (payload) => ({
  type: CONSTANTS.GET_COMPANY_PLAID_VERIFY_ACCOUNT_REQUEST,
  payload
});

export const getCompanyPlaidVerifyAccountsSuccess = (data) => ({
  type: CONSTANTS.GET_COMPANY_PLAID_VERIFY_ACCOUNT_SUCCESS,
  data
});

export const getCompanyPlaidVerifyAccountsFail = (error) => ({
  type: CONSTANTS.GET_COMPANY_PLAID_VERIFY_ACCOUNT_FAIL,
  error
});

export const removePlaidCompanyAccount = (payload, callBack, onError) => ({
  type: CONSTANTS.REMOVE_PLAID_COMPANY_ACCOUNT,
  payload,
  callBack,
  onError
});

export const removePlaidCompanyAccountSuccess = (data) => ({
  type: CONSTANTS.REMOVE_PLAID_COMPANY_ACCOUNT_SUCCESS,
  data
});

export const removePlaidCompanyAccountFail = (error) => ({
  type: CONSTANTS.REMOVE_PLAID_COMPANY_ACCOUNT_FAIL,
  error
});

export const getCorporateSilaCompany = (payload) => ({
  type: CONSTANTS.GET_SILA_COMPANY,
  payload
});

export const getCorporateSilaCompanySuccess = (data) => ({
  type: CONSTANTS.GET_SILA_COMPANY_SUCCESS,
  data
});

export const getCorporateSilaCompanyFail = (error) => ({
  type: CONSTANTS.GET_SILA_COMPANY_FAIL,
  error
});

export const fetchCompanyWalletBalRequest = (companyID) => ({
  type: CONSTANTS.FETCHING_COMPANY_WALLET_BAL_REQUEST,
  companyID
});

export const fetchCompanyWalletBalSuccess = (data) => ({
  type: CONSTANTS.FETCHING_COMPANY_WALLET_BAL_SUCCESS,
  data
});

export const fetchCompanyWalletBalFail = (error) => ({
  type: CONSTANTS.FETCHING_COMPANY_WALLET_BAL_FAIL,
  error
});

export const fetchedCompanyWalletBalReset = () => ({
  type: CONSTANTS.FETCHED_COMPANY_WALLET_BAL_RESET
});

export const deleteCompanyAccountRequest = (companyID, payload) => ({
  type: CONSTANTS.DELETE_COMPANY_ACCOUNT_REQUEST,
  companyID,
  payload
});

export const deleteCompanyAccountSuccess = (data) => ({
  type: CONSTANTS.DELETE_COMPANY_ACCOUNT_SUCCESS,
  data
});

export const deleteCompanyAccountFail = (error) => ({
  type: CONSTANTS.DELETE_COMPANY_ACCOUNT_FAIL,
  error
});

export const deleteCompanyAccountReset = () => ({
  type: CONSTANTS.DELETE_COMPANY_ACCOUNT_RESET
});

export const toggleWalletNotSetModal = (visible) => ({
  type: CONSTANTS.TOGGLE_WALLET_NOT_SET_MODAL,
  visible
});

export const setCompanyPaymentPlanRequest = (payload) => ({
  type: CONSTANTS.SET_COMPANY_PAYMENT_PLAN_REQUEST,
  payload
});

export const setCompanyPaymentPlanSuccess = (data) => ({
  type: CONSTANTS.SET_COMPANY_PAYMENT_PLAN_SUCCESS,
  data
});

export const setCompanyPaymentPlanFail = (error) => ({
  type: CONSTANTS.SET_COMPANY_PAYMENT_PLAN_FAIL,
  error
});

export const registerCompany = (payload) => ({
  type: CONSTANTS.REGISTER_COMPANY,
  payload
});

export const clearCompany = () => ({
  type: CONSTANTS.CLEAR_COMPANY
});

export const updateCompany = (payload) => ({
  type: CONSTANTS.UPDATE_COMPANY,
  payload
});

export const setCompanyPlaidConnectionFailed = (payload) => ({
  type: CONSTANTS.SET_COMPANY_PLAID_CONNECTION_FAILED,
  payload
});

export const getCompanyZealLoginUrlRequest = ({ data, errCb }) => ({
  type: CONSTANTS.GET_ZEAL_LOGIN_URL_REQUEST,
  payload: { data, errCb }
});

export const getCompanyZealLoginUrlSuccess = (data) => ({
  type: CONSTANTS.GET_ZEAL_LOGIN_URL_SUCCESS,
  data
});

export const getCompanyZealLoginUrlFail = (error) => ({
  type: CONSTANTS.GET_ZEAL_LOGIN_URL_FAIL,
  error
});

export const toggleCreateCompanyModal = (value) => ({
  type: CONSTANTS.TRIGGER_CREATE_COMPANY_MODAL,
  payload: value
});
